%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 17c14f584f7d29740952e55a51d6a1fe, type: 3}
  m_Name: BossDragon
  m_EditorClassIdentifier: 
  unitModel: {fileID: 3241138547371686306, guid: 18bd2c6cbea9e624a8241325c3007f92,
    type: 3}
  heroClass: 28
  isHealer: 0
  isInternal: 1
  isBoss: 1
  level: 0
  attackSpeed: 1
  baseHP: 3500
  baseGCDMultiplier: 100
  unitName: Smolderak
  unitSpec: 
  icon: {fileID: 2800000, guid: a23e082d7a100634383ef0082e371229, type: 3}
  backgroundColor: {r: 0.8588235, g: 0.8588235, b: 0.854902, a: 1}
  textColor: {r: 0.4, g: 0.4, b: 0.4, a: 1}
  typeIcon: {fileID: 21300000, guid: 423717ccb76a74e489e5d288c5af5780, type: 3}
  type: HEALER
  description: 
  hitboxScale: {x: 15, y: 4, z: 15}
  selectionCircleScale: {x: 15, y: 3.1, z: 15}
  mouseHitboxScale: {x: 15, y: 4, z: 15}
  hitAnimationType: 17
  dieAnimationType: 18
  animationSpeedMultiplier: 1
  supportsStopWalkAnimation: 0
  isLeftHandClosed: 0
  isRightHandClosed: 0
  dualWields: 0
  runAnimation: {fileID: 7400018, guid: 5c1a7f08c15994365a2d0b0afba374a3, type: 3}
  sprintAnimation: {fileID: 7400018, guid: 5c1a7f08c15994365a2d0b0afba374a3, type: 3}
  idleAnimation: {fileID: 7400004, guid: 5c1a7f08c15994365a2d0b0afba374a3, type: 3}
  stopWalkAnimation: {fileID: 0}
  footstepSounds:
  - {fileID: 8300000, guid: c75d853d28819419f888ae428e053845, type: 3}
  - {fileID: 8300000, guid: 73b33344897394a55963181ab6b5d6fb, type: 3}
  - {fileID: 8300000, guid: 2b7ee34fc58104412b93347642ad061f, type: 3}
  - {fileID: 8300000, guid: 55e0a2cf5ae054f4cb8bb3235320e636, type: 3}
  passiveIcon: {fileID: 21300000, guid: d3857588363cc674ea1157723c39247f, type: 3}
  passiveName: 
  passiveDescription: 
